import * as z from 'zod';

export const replicationFormValidationSchema = z
  .object({
    id: z.number().nullable().optional(),
    resourceId: z.number({
      invalid_type_error: 'fieldRequired',
      required_error: 'fieldRequired',
    }),
    jobId: z
      .number({
        invalid_type_error: 'fieldRequired',
        required_error: 'fieldRequired',
      })
      .nullable()
      .optional(),
    orderId: z
      .number({
        invalid_type_error: 'fieldRequired',
        required_error: 'fieldRequired',
      })
      .nullable()
      .optional(),
    workedHours: z
      .number({
        invalid_type_error: 'fieldRequired',
        required_error: 'fieldRequired',
      })
      .nonnegative({ message: 'nonNegativeNumber' })
      .min(0, { message: 'min_num_0' })
      .max(16, { message: 'max_num_16' }),
    markType: z.string({
      invalid_type_error: 'fieldRequired',
      required_error: 'fieldRequired',
    }),
    note: z.string().max(255, { message: 'max_255' }).nullable().optional(),
    days: z
      .array(
        z.number({
          invalid_type_error: 'fieldRequired',
          required_error: 'fieldRequired',
        }),
      )
      .min(1, { message: 'days_required' }),
    startDate: z.string({
      invalid_type_error: 'fieldRequired',
      required_error: 'fieldRequired',
    }),
    endDate: z.string({
      invalid_type_error: 'fieldRequired',
      required_error: 'fieldRequired',
    }),
  })
  .refine(
    (data) => {
      if (data.markType === 'WorkedHours') {
        console.log(data.jobId, data.orderId, !!data.jobId && !!data.orderId);
        return !!data.jobId && !!data.orderId;
      }
      return true;
    },
    {
      message: 'fieldRequired',
      path: ['orderId'], // This will be shown in the error path
    },
  );
